import { axiosInstance } from 'api/apiConfig'
import { setNextPageParam, setNextPageQuery } from 'api/apiUtil'
import { useInfiniteQuery, useMutation, useQuery } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string'

//메뉴조회
// /api/menucrte/carte/v1.0/crtDtlMenuList

const getRequestList = async (target, params) => {
  const { data } = await axiosInstance.get(
    `/api/mymen/newmenuprop/v1.0${target ? '/' + target : ''}${objectToQueryString(params)}`,
  )
  return data
}

export const useMenuSrch = (params, isInit) => {
  return useInfiniteQuery(['menuSrch'], () => getRequestList('menuSrch', params), {
    enabled: isInit,
    getNextPageParam: setNextPageParam(params),
  })
}
